import { ChangeDetectorRef, Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, FormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { Inventory } from "../../../core/models/inventory.model";
import { NacNumber } from "../../../core/models/nacNumber/nacNumber.model";
import { TransactionEntry } from "../../../core/models/bankportal.model";
import * as moment from "moment";
import { MerchantCategory } from '../../../core/models/merchantCategory.model';
import { ToastrService } from 'ngx-toastr';
import * as XLSX from 'xlsx';
import * as _ from 'lodash'
import { ValidationErrorHandlerService } from '../../../core/services/validation-error-handler.service';
import { Route, Router } from '@angular/router';
import { BankPortalService, CreateDeploymentRequestCommand, TransactionHeaders } from '../../../web-api-client';
import { Permission } from '../../../auth/permissions';
type AOA = any[][];

@Component({
  selector: 'transaction-entry',
  templateUrl: './transaction-entry.component.html',
  styles: ['.invalid-autocomplete > .autocomplete-container > .input-container{border: 1px solid red !important;}'],
  styleUrls: ['./transaction-entry.component.scss']
})
export class TransactionEntryComponent implements OnInit {

  dataForExcel = new TransactionEntry();
  dataFromExcel: TransactionEntry[] = [];
  transactionHeader = new Array<TransactionHeaders>();
  //data: AOA = [['MERCHANT NAME','MERCHANT LOCATION','DISTRICT','PHONE NUMBER','MOBILE NO','MERCHANT ID','TERMINAL ID','FINAL VALUE','COMBINE VALUE','CONTACT PERSON','PAN NUMBER','NATURE OF BUSINESS','KVC 1','MODEL','KVC 2','COMPONENT 1','COMPONENT 2','MCC','BRANCH NAME']];
  data: AOA = [['SETTLEMENT DATE', 'TRANSACTION DATE', 'ID MERCHANT', 'ID TERMINAL', 'CARD MASK', 'RNN', 'CARD TYPE', 'NETWORK', 'MERCHANT NAME', 'MERCHANT ACCOUNT', 'TRANSACTION AMOUNT', 'MSC RATE', 'MSC AMOUNT', 'SETTLEMENT AMOUNT']];

  wopts: XLSX.WritingOptions = { bookType: 'xlsx', type: 'array' };
  fileName: string = 'Upload_Format.xlsx';
  public files: any;
  public fileLength: any;
  dsitrictExportName: string = 'DistrictList.xlsx';
  public isReqSave: boolean = false;
  @ViewChild('scrollMe', { static: false }) private myScrollContainer!: ElementRef;
  public requestFilter: any;
  public editIndex!: number;
  public submitted: boolean = false;
  public isUpdate: boolean = false;
  public isShowTable: boolean = false;
  public isHeaderExists: boolean = false;
  public isHeaderMatched: boolean = false;
  bankBranches = [];
  public editted: boolean = false;
  @HostListener('scroll', ['$event'])
  todayDate = new Date();
  rows2: Inventory[] = [];
  terminalTypeList: Inventory[] = [];
  p: number = 1;
  loadingIndicator!: boolean;
  columnDefs: any[] = [];
  excelArray: any[] = [];
  columns: any[] = [];
  selCategory: any;
  category: MerchantCategory[] = [];
  public provinces: String = "province";
  public uploadType: string = "";
  public formResetToggle = true;
  selDistrict = null;
  keyword = 'branchName';
  selProvince = null;
  registerForm!: UntypedFormGroup;
  updateForm!: UntypedFormGroup;
  selSettlementSecondaryId = null;
  selSettlementPrimaryId = null;
  selTransactionSecondaryId = null;
  selTransactionPrimaryId = null;
  selMerchantCategoryId = null;
  selCurrency = null;
  rowsNacNumber: NacNumber[] = [];
  public loading: boolean = false;
  rowsTerminalId: CreateDeploymentRequestCommand[] = [];
  public TransactionEntryForm!: UntypedFormGroup;
  public TransactionUpdateForm!: UntypedFormGroup;
  public filterdate = moment().format('MMM/DD/YYYY');
  rows: any;
  isUpdateHeader: boolean = false;
  isshowUpdateHeader: boolean = false;
  isShowTransactionHeader: boolean = true;
  isShowImportFromExcel: boolean = false;
  readonly Permission = Permission;

  file: any;
  arrayBuffer: any;
  filelist!: any[];
  radioItems: string[];

  bulkUpload: boolean = false;
  configHeader: boolean = true;
  constructor(private formBuilder: UntypedFormBuilder,
    private _toastr: ToastrService,
    private _el: ElementRef,
    private _validationError: ValidationErrorHandlerService,
    private bankPortalService: BankPortalService,
    private bankPortalS: BankPortalService,
    private _router: Router,
    private _ref: ChangeDetectorRef) {
    this.radioItems = ['Configure Excel Header', 'Import From Excel'];
    this.uploadType = 'Configure Excel Header', 'New Header';

    //this.uploadType = 'singleEntry', 'importExcel';
    this.filterdate;
  }
  public invoiceForm!: UntypedFormGroup;
  public depRequest = new CreateDeploymentRequestCommand();
  public transactionEntry = new TransactionEntry();
  public deploymentRequestList: Array<TransactionEntry> = new Array<TransactionEntry>();
  public newRow: Array<any> = new Array<any>();
  public addedRow: Array<any> = new Array<any>();
  public bankPortal: Array<TransactionEntry> = new Array<TransactionEntry>();
  public BankPortalDepReqVM: Array<TransactionEntry> = new Array<TransactionEntry>();
  public deploymentReqId!: string;

  ngOnInit() {
    this.TransactionEntryForm = this.formBuilder.group(
      {
        SettlementDate: ["", Validators.required],
        TrxDate: ["", Validators.required],
        MerchantNumber: ["", [Validators.required]],
        TerminalNumber: ["", [Validators.required]],
        CardMask: ["", Validators.required],
        RRN: ['', [Validators.required]],
        CardType: ['', [Validators.required]],
        Network: ["", Validators.required],
        MerchantName: ["", Validators.required],
        MerchantAccount: ["", Validators.required],
        TrxAmount: ["", Validators.required],
        MSCRate: ["", Validators.required],
        MSCAmount: ["", Validators.required],
        SettlementAmount: ["", Validators.required],
      });

    this.registerForm = this.formBuilder.group({
      transactionEntryArray: this.formBuilder.array([])
    });

    this.loadTransactionheader();

    this.TransactionUpdateForm = this.formBuilder.group(
      {

        id: [""],
        settlementDate: ["", Validators.required],
        trxDate: ["", Validators.required],
        merchantNumber: ["", [Validators.required]],
        terminalNumber: ["", [Validators.required]],
        cardMask: ["", Validators.required],
        rrn: ['', [Validators.required]],
        cardType: ['', [Validators.required]],
        network: ["", Validators.required],
        merchantName: ["", Validators.required],
        merchantAccount: ["", Validators.required],
        trxAmount: ["", Validators.required],
        mscRate: ["", Validators.required],
        mscAmount: ["", Validators.required],
        settlementAmount: ["", Validators.required],
      });

    this.updateForm = this.formBuilder.group({
      transactionEntryArray: this.formBuilder.array([])
    });

  }

  get f() {
    return this.TransactionEntryForm.controls;
  }
  get TransactionUpdateFormControls() {
    return this.TransactionUpdateForm.controls;
  }


  private transactionEntryRow(): UntypedFormGroup {
    return this.formBuilder.group({
      SettlementDate: ['', Validators.required],
      TrxDate: ['', Validators.required],
      MerchantNumber: ['', [Validators.required]],
      TerminalNumber: ['', [Validators.required]],
      CardMask: ['', Validators.required],
      RRN: ['', [Validators.required]],
      CardType: ['', [Validators.required]],
      Network: ['', Validators.required],
      MerchantName: ['', Validators.required],
      MerchantAccount: ['', Validators.required],
      TrxAmount: ['', Validators.required],
      MSCRate: ['', Validators.required],
      MSCAmount: ['', Validators.required],
      SettlementAmount: ['', Validators.required],
    });
  }

  get transactionEntryArray(): UntypedFormArray {
    return this.registerForm.get('transactionEntryArray') as UntypedFormArray;
  }

  onAddRequest() {

    this.submitted = true;
    //this.goToBottom();
    //this._ref.detectChanges();
    if (this.TransactionEntryForm.invalid) {
      return;
    }
    else {
      // this.TransactionEntryForm.value.SettlementPrimaryId = this.selSettlementPrimaryId = this.rowsNacNumber[0].id;
      // this.TransactionEntryForm.value.SettlementSecondaryId = this.selSettlementSecondaryId = this.rowsNacNumber[0].id;
      // this.TransactionEntryForm.value.TransactionPrimaryId = this.selTransactionPrimaryId = this.rowsNacNumber[0].id;
      // this.TransactionEntryForm.value.TransactionSecondaryId = this.selTransactionSecondaryId = this.rowsNacNumber[0].id;
      // this.addedRow.push(JSON.parse(JSON.stringify(this.TransactionEntryForm.value)));
      // this.TransactionEntryForm.reset();
      // this.depRequest.BankPortalDepReqVM = this.addedRow;
      // this.deploymentRequestList.push(JSON.parse(JSON.stringify(this.transactionEntry)));

      // this.transactionEntry = new TransactionEntry();
      // //this.isShowTable = this.deleteRequest.length > 0 ? true : false;
      // this.alertService.showMessage("", `One Request added !`, MessageSeverity.success);
      // this.submitted = false;
      // this.loading = false;
      // this.TransactionEntryForm.reset();
      console.log(this.TransactionEntryForm.value.itemRows);
      this.bankPortalService.bankPortal_PostTransactionHeader(this.TransactionEntryForm.value).subscribe(() => this.onSuccess(), error => this.unSuccess(error));
      this.submitted = false;
      this.hide();
    }
  }

  onSuccess() {
    this._toastr.success("Successfully Added !!", "");
    //this.showModelBox = false;
    this.onRadioButtonClicked('Import From Excel');
    this.TransactionEntryForm.reset();
    this.submitted = false;
    this.loadTransactionheader();
  }

  unSuccess(error: any) {
    // this.notify.showError("Error", "Error !!");
  }

  hide() {
    //this.showModelBox = false;
    this.TransactionEntryForm.reset();
    // this.isUpdating = false;
  }
  selectRequest(value: number) {
    this.transactionEntry = new TransactionEntry();
    this.addedRow = new Array<any>();
    this.requestFilter = value;
    //this.provinces = "";
  }

  initItemRows(): UntypedFormGroup {
    return this.formBuilder.group({
      // list all your form controls here, which belongs to your form array


    });
  }
  addNewRow() {
    // control refers to your form array
    const control = <UntypedFormArray>this.invoiceForm.controls['itemRows'];
    //add new formgroup
    control.push(this.initItemRows());
  }
  saveItemRows() {
    //this.deploymentEdit = this.invoiceForm.getRawValue();

  }


  deleteRow(index: number) {
    if (this.editIndex == index) {
      this._toastr.error(`It can't be delete as it is open in Edit Mode `, "Sorry");
    }
    else {
      this.addedRow.splice(index, 1);
      this._toastr.show(`Request Deleted !!`, "");

    }

  }
  // editRow(index: number) {

  //   this.isUpdate = true;
  //   this.editted = true;
  //   this.editIndex = index;
  //   this.deploymentRequest = Object.assign(this.deploymentRequest, this.addedRow[index]);
  //   this.deploymentRequest.RequestedDate = moment(this.deploymentRequest.RequestedDate).format('MMM/DD/YYYY');
  //   this.selSettlementPrimaryId = this.rowsNacNumber.filter(x => x.id == this.deploymentRequest.SettlementPrimaryId)[0].phoneNumber;
  //   this.selSettlementSecondaryId = this.rowsNacNumber.filter(x => x.id == this.deploymentRequest.SettlementSecondaryId)[0].phoneNumber;
  //   this.selTransactionPrimaryId = this.rowsNacNumber.filter(x => x.id == this.deploymentRequest.TransactionPrimaryId)[0].phoneNumber;
  //   this.selTransactionSecondaryId = this.rowsNacNumber.filter(x => x.id == this.deploymentRequest.TransactionSecondaryId)[0].phoneNumber;

  //   this.TransactionEntryForm.patchValue(this.deploymentRequest);
  //   this.goToTop();
  //   this.uploadType = 'Single Entry';
  // }
  // UpdateRequest() {
  //   this.newRow = new Array<any>();
  //   this.newRow.push(JSON.parse(JSON.stringify(this.deploymentRequest)));
  //   //this.addedRow.splice(this.editIndex, 1);
  //   this.addedRow.splice(this.editIndex, 1, ...this.newRow);
  //   this.isUpdate = false;
  //   this.editted = false;

  //   this.deploymentRequest = new TransactionEntry();
  //   this.editIndex = -1;
  //   this.TransactionEntryForm.reset();
  //   this.goToBottom();
  // }
  // Cancel() {
  //   this.isUpdate = false;
  //   this.editted = false;
  //   this.deploymentRequest = new TransactionEntry();
  //   this.deploymentRequest.RequestedDate = moment().format('MMM/DD/YYYY');
  //   this.editIndex = -1;
  // }
  // SubmitDeploymentRequest() {
  //   //  debugger;
  //   // this.depRequest.BankPortalDepReqVM = Object.assign(this.depRequest.BankPortalDepReqVM, this.BankPortalDepReqVM);
  //   this.isReqSave = true;
  //   //this.notifyService.showInfo("Please wait while request is being submitted","",{});
  //   this.toaster.warning('Please wait while request is being submitted', '', {
  //     timeOut: 20000,
  //   });
  //   this.bankPortalService.newDeploymentReqFromBank(this.depRequest)
  //     .subscribe(results => this.onDeploymentRequestSuccessful(results),
  //       error => this.onDeploymentRequestFailed(error));

  // }

  onDeploymentRequestSuccessful(res: CreateDeploymentRequestCommand) {

    this.selDistrict = null;
    this.selProvince = null;
    this.selSettlementPrimaryId = null;
    this.selSettlementSecondaryId = null;
    this.selTransactionPrimaryId = null;
    this.selTransactionSecondaryId = null;
    this.transactionEntry = new TransactionEntry();
    this.addedRow = [];
    this._toastr.success("Request submitted successfully", "Success");
    this.isReqSave = false;
    this.TransactionEntryForm.reset();

  }

  onDeploymentRequestFailed(error: any) {
    this._toastr.error("Cannot submit deployment request", "Error");
    //this.alertService.showStickyMessage(error, null, MessageSeverity.error);
    //this.toaster.error(error);

    this.isReqSave = false;
  }
  ChangeDate(value: any) {
  }
  ChangeDateWhileEdit(date: Date) {
    this.todayDate = date;
  }
  goToTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }
  goToBottom() {
    const el: HTMLDivElement = this._el.nativeElement;
    el.scrollTop = Math.max(0, el.scrollHeight - el.offsetHeight);

  }
  onScroll(event: any) {
    // visible height + pixel scrolled >= total height
    if (event.target.offsetHeight + event.target.scrollTop >= event.target.scrollHeight) {

    }
  }

  addfile(event: { target: { files: any[]; }; }) {
    this.file = event.target.files[0];
  }
  showInTable() {
    // this.isHeaderMatched=true;
    this.transactionEntryArray.controls = [];
    this.dataFromExcel = [];
    // this.file = event.target.files[0];
    let fileReader = new FileReader();
    fileReader.readAsArrayBuffer(this.files[0]);
    fileReader.onload = (e) => {
      this.arrayBuffer = fileReader.result;
      var data = new Uint8Array(this.arrayBuffer);
      var arr = new Array();
      for (var i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
      var bstr = arr.join("");
      var workbook = XLSX.read(bstr, { type: "binary" });
      var first_sheet_name = workbook.SheetNames[0];
      //  first_sheet_name.trim();
      var worksheet = workbook.Sheets[first_sheet_name];

      //console.log(XLSX.utils.sheet_to_json(worksheet,{} ));

      var arraylist: any = XLSX.utils.sheet_to_json(worksheet, { raw: true });
      const excelArrayHeaders =_.map(Object.keys(arraylist[0]),_.toLower);
      const filteredTranHeader = _.omit(this.TransactionUpdateForm.value, 'id');
      const TransactionHeader = _.map(Object.values(filteredTranHeader), _.toLower);
      const isEqualHeaders=_.isEqual(_.sortBy(TransactionHeader), _.sortBy(excelArrayHeaders));

      if (isEqualHeaders) {
        // this.headers = Object.keys(arraylist[0]);
        this.isShowTable = arraylist.length > 0 ? true : false;
        for (let item of arraylist) {
          this.dataForExcel = new TransactionEntry();
          this.dataForExcel.SettlementDate = item[this.TransactionUpdateForm.value.settlementDate];
          this.dataForExcel.TrxDate = item[this.TransactionUpdateForm.value.trxDate];
          this.dataForExcel.MerchantNumber = item[this.TransactionUpdateForm.value.merchantNumber];
          this.dataForExcel.TerminalNumber = item[this.TransactionUpdateForm.value.terminalNumber];
          this.dataForExcel.CardMask = item[this.TransactionUpdateForm.value.cardMask];
          this.dataForExcel.RRN = item[this.TransactionUpdateForm.value.rrn];
          this.dataForExcel.CardType = item[this.TransactionUpdateForm.value.cardType];
          this.dataForExcel.Network = item[this.TransactionUpdateForm.value.network];
          this.dataForExcel.MerchantName = item[this.TransactionUpdateForm.value.merchantName];
          this.dataForExcel.MerchantAccount = item[this.TransactionUpdateForm.value.merchantAccount];
          this.dataForExcel.TrxAmount = item[this.TransactionUpdateForm.value.trxAmount];
          this.dataForExcel.MSCRate = item[this.TransactionUpdateForm.value.mscRate];
          this.dataForExcel.MSCAmount = item[this.TransactionUpdateForm.value.mscAmount];
          this.dataForExcel.SettlementAmount = item[this.TransactionUpdateForm.value.settlementAmount];
          this.dataForExcel = Object.assign(this.dataForExcel, item);
          this.dataFromExcel.push(this.dataForExcel);
          this.transactionEntryArray.push(this.transactionEntryRow());
          this.transactionEntryArray.patchValue(this.dataFromExcel);
        }
      }
      else{
        this._toastr.error("Headers not matched. Please configure headers to import from excel.", "Error");
      }
    }
  }


  //  cardMask: "dsadasd"
  // cardType: "dsadad"
  // merchantAccount: "dasdad"
  // merchantName: "dsadasd"
  // merchantNumber: "sdsadasd"
  // mscAmount: "dasda"
  // mscRate: "dasdasd"
  // network: "dsdadsd"
  // rrn: "dasdasd"
  // settlementAmount: "dasdas"
  // settlementDate: "sadadad"
  // terminalNumber: "wsdasd"
  // trxAmount: null
  // trxDate: null
  onSubmit() {
    this.submitted = true;
    if (this.transactionEntryArray.invalid) {
      return;
    }
    this.depRequest.bankPortalDepReqVM = [];
    for (let i = 0; i < this.transactionEntryArray.value.length; i++) {
      this.depRequest.bankPortalDepReqVM.push(this.transactionEntryArray.value[i]);
      // this.deploymentRequestList.push(JSON.parse(JSON.stringify(this.depRequest)));
    }
    this.bankPortalService.bankPortal_PostTransaction(this.depRequest.bankPortalDepReqVM).subscribe(res => {
      this._toastr.success("Successfully Added  Transaction Record!!", "");
      this._router.navigate(['./transactionReport']);
      this.isShowTable = false;
      this.registerForm.reset();
    },
      err => {
        console.log(err);
        this._validationError.handleValidationErrorsArray(this.transactionEntryArray, err.error);
        console.log(err);

      });
  }

  addRequest() {
    this.transactionEntryArray.push(this.transactionEntryRow());

  }

  deleteRequest(index) {
    this.transactionEntryArray.removeAt(index);
  }

  addFile($event) {
    let fileExtension = $event.target.files[0].name.split('.').pop();
    if (fileExtension == 'csv' || fileExtension == 'xlsx' || fileExtension == 'xls') {
      this.prepareFilesList($event.target.files);
    }
    else {
      this._toastr.error("Error", "File Not Supported");
    }
  }

  onFileDropped($event) {
    let fileExtension = $event[0].name.split('.').pop();
    if (fileExtension == 'csv' || fileExtension == 'xlsx' || fileExtension == 'xls') {
      this.prepareFilesList($event);
    }
    else {
      this._toastr.error("Error", "File Not Supported");
    }
  }

  prepareFilesList(file: any) {
    file.progress = 0;
    this.files = file
    this.fileLength = file.length;
    this.uploadFilesSimulator();
  }

  uploadFilesSimulator() {
    if (this.files.length <= 0) {
      return;
    }
    else {
      const progressInterval = setInterval(() => {
        if (this.files.progress === 100) {
          clearInterval(progressInterval);
          this.showInTable();
        } else {
          this.files.progress += 5;
        }
      }, 200);
    }
  }

  /**
  * Delete file from files list
  * @param index (File index)
  */
  deleteFile() {
    this.files = 0;
    this.fileLength = 0;
    this.isShowTable = false;
  }

  /**
   * format bytes
   * @param bytes (File size in bytes)
   * @param decimals (Decimals point)
   */
  formatBytes(bytes, decimals) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }
  district(event) {
    console.log(event);
  }
  BranchName(event) {
  }
  export(): void {
    /* generate worksheet */
    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(this.data);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, this.fileName);
  }
  exportDisrict(): void {
    /* generate worksheet */
    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(this.data);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, this.dsitrictExportName);
  }

  onChangeSearch(search: string) {
    // fetch remote data from here
    // And reassign the 'data' which is binded to 'data' property.
  }

  onFocused(e: any) {
  }
  bankBranchselectEvent(event: { branchName: any; }) {
    this.TransactionEntryForm.patchValue({ BranchName: event.branchName });
    //this.deploymentRequest.BranchName = item.branchName;
  }

  changeDistrictEvent(event: { name: any; provinces: any; }) {
    this.TransactionEntryForm.patchValue({ Province: event.provinces[0] });
  }

  terminalTypeselectEvent(event) {
    this.TransactionEntryForm.patchValue({ InventoryId: event.id });
  }

  currencyTypeselectEvent(event: { text: any; }) {
    this.TransactionEntryForm.patchValue({ Currency: event.text });
  }


  keyPressNumbers(event: { which: any; keyCode: any; preventDefault: () => void; }) {
    var charCode = (event.which) ? event.which : event.keyCode;
    // Only Numbers 0-9
    if ((charCode < 48 || charCode > 57)) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }

  onRadioButtonClicked(value: any) {
    this.uploadType = value;
    if (this.uploadType == 'Import From Excel') {
      this.isShowImportFromExcel = true;
      this.isShowTransactionHeader = false;
      this.isshowUpdateHeader = false;
    } else {
      if (this.isHeaderExists) {
        this.isShowImportFromExcel = false;
        // this.isShowTransactionHeader = false;
        // this.isshowUpdateHeader= true;
      }
      else {
        this.isShowImportFromExcel = false;
        // this.isShowTransactionHeader = true;
        // this.isshowUpdateHeader= false;
      }
    }


    // switch(value){
    //   case 'Import From Excel':
    //             this.bulkUpload = true;
    //             this.isUpdateHeader = false;
    //             this.configHeader = false;
    //             break;
    //   case 'Configure Excel Header':
    //           this.bulkUpload = false; 
    //           if(!this.configHeader == true && !this.isUpdateHeader==true){
    //             this.configHeader = true;
    //           }else{
    //             this.isUpdateHeader = true;  
    //           }


    //           break;
    //   default:
    //     break;
    // }


    // if(value == 'Import From Excel'){
    //   this.bulkUpload = true;
    //   this.isUpdateHeader = false;
    //   this.configHeader = false;
    // }else if(value == 'Configure Excel Header'){    
    //       this.bulkUpload = false; 
    //       this.configHeader = true;
    //       this.isUpdateHeader = true;  

    // }else{
    //   this.configHeader= true;
    //   this.bulkUpload = false;
    // }
    this.submitted = false;
  }


  loadTransactionheader() {
    this.bankPortalService.bankPortal_GetTransactionHeaders().subscribe(res => {
      this.transactionHeader = res;
      if ((this.transactionHeader != null || this.transactionHeader != undefined) && this.transactionHeader.length != 0) {
        this.isHeaderExists = true;
        this.TransactionUpdateForm.patchValue(this.transactionHeader[0]);
        // this.isUpdateHeader = true; 
        // this.isshowUpdateHeader= true;
      }
      else {
        this.isHeaderExists = false;
      }
    },
      error => this.unSuccess(error));

  }

  onUpdate() {
    this.submitted = true;
    if (this.TransactionUpdateForm.invalid)
      return;
    //console.log(this.BankBranchEditForm.value);
    this.bankPortalS.bankPortal_EditTransactionHeader(this.TransactionUpdateForm.value)
      .subscribe(user => this.updateSuccess(),
        error => this.updateFail(error));
  }

  updateSuccess() {
    this._toastr.success("Updated Successfully", "Success")
    this.submitted = false;

  }

  updateFail(error) {
    //this.notify.showError("Save Error", "Cannot be edited");
    this._toastr.error("Cannot be edited", "Save Error");

  }

}

